<template>
	<BaseCard
		:is-editable="!isProcessFinished && isEditAllowed"
		:title="title"
		@clickEdit="$router.push({ name: editRoute, params: { id: $route.params.processId || $route.params.id } })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons>
			<slot name="icons" />
		</template>

		<div v-if="company">
			<BaseCardRow :value="company.name" :missing-label="$t('name')"></BaseCardRow>
			<BaseCardRow v-if="street != null" :value="street" :missing-label="$t('street')" />
			<BaseCardRow v-else :value="company.poBox" :missing-label="$t('po_box')" />
			<BaseCardRow :value="city" :missing-label="$t('city')" />
			<BaseCardRow :value="phoneNumber" :missing-label="$t('phone')" :label="$t('phone')" class="mt-6"></BaseCardRow>
			<BaseCardRow :value="email" :missing-label="$t('e_mail')"></BaseCardRow>
			<div v-if="mandate.showMandate" class="font-bold text-red-300 pt-2">{{ $t('mandate_ended_early_msg', { message: mandate.note }) }}</div>
			<BaseCardRow
				v-if="customerConsultantName"
				:label="$t('customer_consultant_short')"
				:value="customerConsultantName"
				:missing-label="$t('customer_consultant_short')"
			></BaseCardRow>
		</div>

		<div class="font-bold" v-else>
			{{ getMissingValue }}
		</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';

export default {
	name: 'CompanyCard',
	components: { BaseCard, BaseCardRow },
	props: {
		company: { required: true },
		isProcessFinished: {},
		title: { required: true },
		isEditAllowed: { type: Boolean, default: true },
		editRoute: { type: String },
		missingValue: {},
		customerConsultant: { default: false },
		showCustomerConsultantPhoneNumber: { default: false },
		showCustomerConsultantEmail: { default: false },
		isToggleOpen: { type: Boolean, default: true },
		mandate: {
			default: function() {
				return { showMandate: false };
			},
		},
	},
	computed: {
		getMissingValue() {
			return this.missingValue || this.title + ' ' + this.$t('not_stored');
		},
		street: function() {
			if (this.company.street === undefined) {
				return null;
			}
			return concatArray([this.company.street, this.company.houseNumber]);
		},
		city() {
			return concatArray([this.company.city.zipCode, this.company.city.name]);
		},
		customerConsultantName: function() {
			// if (this.customerConsultant.gender === 'company') {
			// 	return concatArray(['Firma', this.customerConsultant.company.name]);
			// }
			return concatArray([this.customerConsultant.title, this.customerConsultant.firstName, this.customerConsultant.lastName]);
		},
		phoneNumber: function() {
			if (this.showCustomerConsultantPhoneNumber && (this.customerConsultant?.cellNumber || this.customerConsultant?.phoneNumber))
				return this.customerConsultant?.cellNumber || this.customerConsultant?.phoneNumber;
			else return this.company.phoneNumber;
		},
		email: function() {
			if (this.showCustomerConsultantEmail && this.customerConsultant.email) return this.customerConsultant.email;
			else return this.company.email;
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
